import { differenceInMinutes, setDate } from 'date-fns';
import { MINUTES_IN_DAY } from '../../constants';
import type { ScheduleSolversDisplayConfigType } from '../../types';
import { getDateFromControlValue } from '../../utils/get-date-obj';

export const daily = ({
  freq = 1,
  endDate,
  startDate,
  userDate,
  scheduleRepeatEnds,
  scheduleRepeatEndsDate,
  scheduleRepeatEndsOccurrences
}: ScheduleSolversDisplayConfigType) => {
  const viewDurationInMinutes = differenceInMinutes(endDate, startDate);
  const fromNowToStartInMinutes = differenceInMinutes(userDate, startDate);

  const frequency = MINUTES_IN_DAY * freq;
  const timeFromStart = fromNowToStartInMinutes % frequency;

  if (
    scheduleRepeatEnds === 'onDate' &&
    userDate.getTime() >=
      getDateFromControlValue(scheduleRepeatEndsDate).getTime()
  ) {
    return false;
  }

  if (scheduleRepeatEnds === 'afterOccurrences') {
    const lastDay = setDate(
      startDate,
      startDate.getDate() + Number(scheduleRepeatEndsOccurrences) * freq
    );
    if (userDate.getTime() > lastDay.getTime()) {
      return false;
    }
  }

  return timeFromStart <= viewDurationInMinutes && fromNowToStartInMinutes >= 0;
};
